export default __webpack_public_path__ + "bb7698b68375d85ac81280a93f879cd7.svg";